
(function () {
  'use strict';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}

  function boot() {

  var LEAD_DAYS = 3;
  var MAX_DAYS = 90;

  var ref = new URLSearchParams(window.location.search).get('ref');
  var workerUrl = "https://soto-api.valardigital.com"; // default

  // DOM handles
  var loadingEl = document.getElementById('ds-loading');
  var errorEl = document.getElementById('ds-error');
  var errorMsgEl = document.getElementById('ds-error-message');
  var formEl = document.getElementById('ds-form');
  var date1El = document.getElementById('ds-date-1');
  var submitBtn = document.getElementById('ds-submit');
  var successEl = document.getElementById('ds-success');
  var confirmed1El = document.getElementById('ds-confirmed-1');

  var orderName = '';

  if (!ref) {
    showError('Missing order reference. Please use the link from your confirmation email.');
    return;
  }

  // Start disabled — enabled once both dates are selected
  submitBtn.disabled = true;
  
  init();

  // ----------------------------------------------------------------
  // Bootstrap
  // ----------------------------------------------------------------

  function init() {
    verifyOrder()

      .then(function (order) {
        // Store order name for success state
        orderName = order.order_name || '';

        // Personalize heading
        if (order.customer_first_name) {
          var h1 = document.querySelector('.delivery-slot-header h1');
          if (h1) h1.textContent = 'Hi ' + order.customer_first_name + ', choose your delivery date';
        }

        // Already submitted — show existing date, skip form
        if (order.already_submitted) {
          showSuccess(
            formatForDisplay(order.slot_preference_1)
          );
          loadingEl.style.display = 'none';
          return;
        }

        // Delivery blocked — no delivery slot needed
        if (order.has_delivery_blocked) {
          showDeliveryBlockedMessage();
          loadingEl.style.display = 'none';
          return;
        }

        // Show order ID in form
        var formOrderIdEl = document.getElementById('ds-form-order-id');
        if (formOrderIdEl) formOrderIdEl.textContent = orderName;

        if (order.lead_days != null) LEAD_DAYS = order.lead_days;
        if (order.max_days != null) MAX_DAYS = order.max_days;

        // Order valid, not yet submitted — load blocked dates & show pickers
        return fetchBlockedDates()
          .then(function (blocked) {
            var disableList = buildDisableList(blocked);
            initPickers(disableList);
            showForm();
          });
      })
      .catch(function (err) {
        showError(err.message || 'Unable to verify your order. Please try again later.');
      });
  }

  // ----------------------------------------------------------------
  // Verify order ref before showing pickers
  // ----------------------------------------------------------------

  function verifyOrder() {
    var url = workerUrl + '/api/verify-order?ref=' + encodeURIComponent(ref);
    return fetch(url)
      .then(function (res) {
        if (res.status === 401) throw new Error('This link is invalid or has expired. Please use the link from your confirmation email.');
        if (res.status === 400) throw new Error('Missing order reference. Please use the link from your confirmation email.');
        if (!res.ok) throw new Error('Unable to verify your order (HTTP ' + res.status + ')');
        return res.json();
      });
  }

  // ----------------------------------------------------------------
  // Fetch blocked dates from Worker
  // ----------------------------------------------------------------

  function fetchBlockedDates() {
    var url = workerUrl + '/api/blocked-dates?ref=' + encodeURIComponent(ref);
    return fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to load blocked dates (HTTP ' + res.status + ')');
        return res.json();
      });
  }

  // ----------------------------------------------------------------
  // Merge all 4 blocked-date types into a Flatpickr disable array
  // ----------------------------------------------------------------

  function buildDisableList(data) {
    var disable = [];
    var minDate = addDays(new Date(), LEAD_DAYS);
    var maxDate = addDays(new Date(), MAX_DAYS);

    // 1. specific_dates — use directly
    if (Array.isArray(data.specific_dates)) {
      data.specific_dates.forEach(function (d) { disable.push(d); });
    }

    // 2. one_off_holidays — extract the date field
    if (Array.isArray(data.one_off_holidays)) {
      data.one_off_holidays.forEach(function (h) {
        var dt = typeof h === 'string' ? h : h.date;
        if (dt) disable.push(dt);
      });
    }

    // 3. annual_holidays — resolve to concrete dates within the picker range
    if (Array.isArray(data.annual_holidays)) {
      data.annual_holidays.forEach(function (h) {
        var month, day;
        if (typeof h === 'string') {
          // "MM-DD" format
          var parts = h.split('-');
          month = parseInt(parts[0], 10) - 1;
          day = parseInt(parts[1], 10);
        } else if (h.month && h.day) {
          // { month: 4, day: 17 } format
          month = h.month - 1;
          day = h.day;
        } else if (h.date) {
          // { date: "MM-DD" } format
          var parts2 = h.date.split('-');
          month = parseInt(parts2[0], 10) - 1;
          day = parseInt(parts2[1], 10);
        } else {
          return;
        }

        for (var y = minDate.getFullYear(); y <= maxDate.getFullYear(); y++) {
          var candidate = new Date(y, month, day);
          if (candidate >= minDate && candidate <= maxDate) {
            disable.push(formatDate(candidate));
          }
        }
      });
    }

    // 4. limit_reached_dates — dates that hit the daily order cap
    if (Array.isArray(data.limit_reached_dates)) {
      data.limit_reached_dates.forEach(function (d) { disable.push(d); });
    }

    // 5. recurring_blocked_days — Flatpickr disable function (check getDay())
    if (Array.isArray(data.recurring_blocked_days) && data.recurring_blocked_days.length) {
      var blockedDays = data.recurring_blocked_days.map(Number);
      disable.push(function (date) {
        return blockedDays.indexOf(date.getDay()) !== -1;
      });
    }

    return disable;
  }

  // ----------------------------------------------------------------
  // Flatpickr initialisation
  // ----------------------------------------------------------------

  function initPickers(disableList) {
    var minDate = addDays(new Date(), LEAD_DAYS);
    var maxDate = addDays(new Date(), MAX_DAYS);

    var sharedOpts = {
      dateFormat: 'Y-m-d',
      altInput: true,
      altFormat: 'l, j F Y',
      minDate: minDate,
      maxDate: maxDate,
      disable: disableList,
      disableMobile: true,
      onChange: onDateChange
    };

    flatpickr(date1El, sharedOpts);
  }

  // ----------------------------------------------------------------
  // Validation & submit-button state
  // ----------------------------------------------------------------

  function onDateChange() {
    submitBtn.disabled = !date1El.value;
  }

  // ----------------------------------------------------------------
  // Form submission
  // ----------------------------------------------------------------

  formEl.addEventListener('submit', function (e) {
    e.preventDefault();

    var slot1 = date1El.value;

    if (!slot1) return;

    // Clear previous submit error
    var prevErr = document.getElementById('ds-submit-error');
    if (prevErr) prevErr.style.display = 'none';

    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting\u2026';

    fetch(workerUrl + '/api/submit-slots', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ref: ref,
        slot_preference_1: slot1
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('failed');
        return res.json();
      })
      .then(function () {
        showSuccess(formatForDisplay(slot1));
      })
      .catch(function () {
        showError('We couldn\u2019t save your delivery preferences. Please try again using the link from your confirmation email.');
      });
  });

  // ----------------------------------------------------------------
  // UI state helpers
  // ----------------------------------------------------------------

  function showError(msg) {
    loadingEl.style.display = 'none';
    formEl.style.display = 'none';
    errorMsgEl.textContent = msg;
    errorEl.style.display = 'block';
  }

  function showForm() {
    loadingEl.style.display = 'none';
    formEl.style.display = 'block';
  }

  function showDeliveryBlockedMessage() {
    loadingEl.style.display = 'none';
    formEl.style.display = 'none';
    var blockedEl = document.getElementById('ds-delivery-blocked');
    if (blockedEl) blockedEl.style.display = 'block';
  }

  function showSuccess(display1) {
    formEl.style.display = 'none';
    var refEl = document.getElementById('ds-confirmed-ref');
    if (refEl) refEl.textContent = orderName;
    confirmed1El.textContent = display1;
    successEl.style.display = 'block';
  }

  // ----------------------------------------------------------------
  // Date utilities
  // ----------------------------------------------------------------

  function addDays(date, n) {
    var d = new Date(date);
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + n);
    return d;
  }

  function formatDate(d) {
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var day = String(d.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + day;
  }

  function formatForDisplay(dateStr) {
    var d = new Date(dateStr + 'T00:00:00');
    return d.toLocaleDateString('en-GB', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }

  } // end boot
})();
